export const baseUrl = "https://vamannan-glfunnel-backend-89449968083.asia-south1.run.app/api/v1";
export const baseUrl2 = "https://vamannan-glfunnel-backend-89449968083.asia-south1.run.app/api/v2";
export const leadReportUrl = "https://vamannan-glfunnel-backend-89449968083.asia-south1.run.app/api/v1";
export const productName = "GL Funnel";
export const clientCompanyName = "Vamanan Crm";
export const clientCompanyGreetingTitle = "Welcome To Vamanan Eco System";
export const spinWheelUrl ="https://househuntrewards.in";
export const glPageUrl = "https://crm.glpages.s3-website.ap-south-1.amazonaws.com"
export const googleMapsApiKey = "AIzaSyBlxqaWY6PCRsr1CyXAutmAr33-9mqVn4E";

// export const baseUrl = "http://localhost:7070/api/v1";
// export const baseUrl2 = "http://localhost:7070/api/v2";